import { Outlet, useLocation } from 'react-router-dom';
import BackofficeSidebar from '@/components/BackofficeSidebar';

export default function BackofficeLayout() {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-background" data-testid="backoffice-layout">
      <BackofficeSidebar />
      <main className="md:ml-56 min-h-screen p-4 sm:p-6">
        <Outlet key={location.pathname} />
      </main>
    </div>
  );
}
